import { createText, createLine } from './helpers';

export const participationDetailed = () => ({
  id: 'participation-detailed',
  name: 'Certificate of Participation',
  thumbnail: '/assets/diploma-templates/03_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 197,
        top: 250,
        fontSize: 51,
        fontFamily: 'Cinzel',
        width: 400,
        fontWeight: 'bold'
      }),
      createText({
        text: 'OF PARTICIPATION',
        left: 247,
        top: 300,
        fontSize: 24,
        fontFamily: 'Lato',
        width: 300,
        fontWeight: '600',
        color: '#d3783a'
      }),
      createText({
        text: 'PROUDLY PRESENTED TO',
        left: 259,
        top: 391,
        fontSize: 20,
        fontFamily: 'Lato',
        width: 280,
        color: '#424343'
      }),
      createText({
        text: '{learner_name}',
        left: 9,
        top: 453,
        fontSize: 92,
        fontFamily: 'Allura',
        width: 775
      }),
      createText({
        text: '{program_description}',
        left: 100,
        top: 560,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 594,
        color: '#424343'
      }),
      createText({
        text: 'This certificate was awarded by:',
        left: 197,
        top: 739,
        fontSize: 21,
        fontFamily: 'Lato',
        width: 400,
        color: '#424343'
      }),
      createText({
        text: 'Abraham Barnar',
        left: 65,
        top: 827,
        fontSize: 37,
        fontFamily: 'Great Vibes',
        width: 270
      }),
      createLine({ left: 75, top: 870, width: 250 }),
      createText({
        text: 'ABRAHAM BARNAR',
        left: 65,
        top: 871,
        fontSize: 17,
        fontFamily: 'Lato',
        width: 270,
        color: '#d3783a',
        fontWeight: '600'
      }),
      createText({
        text: 'Managing Director',
        left: 65,
        top: 886,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 270,
        color: '#424343'
      }),
      createText({
        text: 'Nicole Richie',
        left: 459,
        top: 827,
        fontSize: 37,
        fontFamily: 'Great Vibes',
        width: 270
      }),
      createLine({ left: 469, top: 870, width: 250 }),
      createText({
        text: 'NICOLE RICHIE',
        left: 459,
        top: 869,
        fontSize: 17,
        fontFamily: 'Lato',
        width: 270,
        color: '#d3783a',
        fontWeight: '600'
      }),
      createText({
        text: 'Head Coordinator',
        left: 459,
        top: 886,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 270,
        color: '#424343'
      })
    ],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/03_background.svg',
      key: null
    }
  }
});
